import React from "react";
import { useNavigate } from "react-router-dom";

interface RoleCard {
  to: string;
  icon: string;
  title: string;
  desc: string;
  role: string;
}

const ROLES: RoleCard[] = [
  {
    to: "/admin/project-setup",
    icon: "bi-sliders",
    title: "Project Setup",
    desc: "Projects, devices and activities.",
    role: "admin",
  },
  {
    to: process.env.REACT_APP_FIELD_URL || "/field",
    icon: "bi-phone",
    title: "Field Data Input",
    desc: "Daily readings on mobile.",
    role: "field",
  },
  {
    to: "/reviewer/overview",
    icon: "bi-speedometer2",
    title: "Review Result",
    desc: "Dashboards, charts and reports.",
    role: "reviewer",
  },
];

const Landing: React.FC = () => {
  const navigate = useNavigate();
  return (
    <div className="landing">
      <div className="landing-card">
        <div className="brand-row">
          <div className="brand-logo">
            <img
              src={`${process.env.PUBLIC_URL}/buildking-logo.png`}
              alt="HSP logo"
            />
          </div>
          <div>
            <div className="brand-name">HSP Monitoring</div>
          </div>
        </div>

        <div className="role-grid">
          {ROLES.map((r) => (
            <a
              key={r.role}
              className="role-card"
              href={`${r.to}?role=${r.role}`}
              onClick={(e) => {
                e.preventDefault();
                localStorage.setItem("role", r.role);
                if (r.role === "field") {
                  window.location.href = r.to;
                } else {
                  navigate(`${r.to}?role=${r.role}`);
                }
              }}
            >
              <div className="icon">
                <i className={`bi ${r.icon}`} />
              </div>
              <h3>{r.title}</h3>
              <p>{r.desc}</p>
            </a>
          ))}
        </div>
      </div>

      <style>{`
        .landing { min-height: 100vh; background: url('${process.env.PUBLIC_URL}/landing-439416.jpg') center center / cover no-repeat; display: grid; place-items: center; padding: 24px; position: relative; }
        .landing::before { content: ''; position: fixed; inset: 0; background: rgba(10, 20, 50, 0.55); z-index: 0; }
        .landing-card { position: relative; z-index: 1; }
        .landing-card { background: #fff; border-radius: 16px; max-width: 920px; width: 100%; padding: 48px; box-shadow: 0 30px 80px rgba(0,0,0,0.3); }
        .landing h1 { margin: 0 0 6px; font-size: 26px; font-weight: 700; }
        .landing p.sub { color: var(--c-muted); margin: 0 0 32px; }
        .role-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 16px; }
        .role-card { border: 1px solid var(--c-border); border-radius: 12px; padding: 24px 20px; text-align: left; cursor: pointer; transition: all 0.15s; display: flex; flex-direction: column; gap: 8px; text-decoration: none; color: inherit; }
        .role-card:hover { border-color: var(--c-primary); box-shadow: 0 8px 24px rgba(37,99,235,0.15); transform: translateY(-2px); }
        .role-card .icon { width: 44px; height: 44px; border-radius: 10px; background: #eff6ff; color: var(--c-primary); display: grid; place-items: center; font-size: 20px; margin-bottom: 8px; }
        .role-card h3 { margin: 0; font-size: 16px; font-weight: 600; }
        .role-card p { margin: 0; font-size: 13px; color: var(--c-muted); }
        .brand-row { display: flex; align-items: center; gap: 12px; margin-bottom: 36px; }
        .brand-logo { width: 40px; height: 40px; background: var(--c-surface); border: 1px solid var(--c-border); border-radius: 8px; display: grid; place-items: center; overflow: hidden; }
        .brand-logo img { width: 100%; height: 100%; object-fit: contain; display: block; }
        .brand-name { font-weight: 700; font-size: 18px; }
      `}</style>
    </div>
  );
};

export default Landing;
